var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uid)?_c('category-body',{staticClass:"slice-category",attrs:{"uid":_vm.uid}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }